module.exports = __webpack_public_path__ + "img/delete_white.7511e182.svg";